import React from 'react';
import { CheckIcon, GiftIcon, GlobeIcon, LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { volumes, bonuses, MOCKUP_URL } from '../data/content';
const trust = [{
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: LockIcon,
  label: 'Secure checkout'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function OfferSection() {
  return <section id="offer" className="w-full bg-ink py-16 sm:py-24" aria-labelledby="offer-title" data-id="element-189" data-mp="me1zbht9e9ln">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-190" data-mp="rdmyntcccjyw">
        <h2 id="offer-title" className="text-center font-display text-[40px] font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-191" data-mp="rc3is3ulkaxn">
          Get the complete system <span className="text-volt" data-id="element-192" data-mp="2t7dz0scwi631">today</span>
        </h2>
        <p className="mt-3 text-center text-lg text-mist" data-id="element-193" data-mp="2y55n1bafd81y">Everything included in your digital package.</p>

        <div className="mt-10 overflow-hidden rounded-3xl border-2 border-volt bg-navy" data-id="element-194" data-mp="12oa5am5wjrf0">
          <img src={MOCKUP_URL} alt="Complete digital package: 6 volumes and 5 bonuses" className="w-full" data-id="element-195" data-mp="xvqshrf1h0b9" />

          <div className="px-5 pb-8 pt-2 sm:px-8" data-id="element-196" data-mp="sy8jk110ul39">
            <h3 className="font-display text-2xl font-extrabold uppercase text-white" data-id="element-197" data-mp="owdimxn069q0">6 Practical Diagnostic Volumes</h3>
            <ul className="mt-3 space-y-2" data-id="element-198" data-mp="1lmmkopnepxj1">
              {volumes.map(v => <li key={v.title} className="flex items-start gap-2.5 text-[15px] font-medium text-white" data-id="element-199" data-mp="1gnjev2zlrna0">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-200" data-mp="1cl6gizn6qrn9" />
                  {v.title}
                </li>)}
            </ul>

            <h3 className="mt-6 font-display text-2xl font-extrabold uppercase text-white" data-id="element-201" data-mp="172er7acvz7n">
              Plus 5 diagnostic bonuses
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-202" data-mp="3sbiz61b4nu0p">
              {bonuses.map(b => <li key={b.title} className="flex items-start gap-2.5 text-[15px] font-medium text-white" data-id="element-203" data-mp="3tvauc4bu9ed7">
                  <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-volt" aria-hidden="true" data-id="element-204" data-mp="2n6gsc9jaz5y" />
                  <span className="flex-1" data-id="element-205" data-mp="3ksjjo6qsemmm">{b.title}</span>
                  <span className="shrink-0 text-sm text-mist line-through" data-id="element-206" data-mp="3oumxv34uc5bl">${b.value}</span>
                </li>)}
            </ul>

            <div className="mt-8 border-t border-line pt-8 text-center" data-id="element-207" data-mp="3b1x9wt5r4qbu">
              <p className="text-base font-semibold uppercase tracking-wide text-mist" data-id="element-208" data-mp="3fv9v0tb82ezu">Your complete digital package</p>
              <p className="mt-1 text-lg text-mist" data-id="element-209" data-mp="316wvxngu8g14">
                Bonus value alone: <span className="font-bold line-through decoration-alert decoration-2" data-id="element-210" data-mp="363ndygc7dlp6">$99</span>
              </p>
              <p className="mt-2 font-display text-2xl font-extrabold uppercase text-white" data-id="element-211" data-mp="2s5ypyzmu9yfw">Today only</p>
              <p className="font-display text-[96px] font-extrabold leading-none text-volt sm:text-[120px]" data-id="element-212" data-mp="2x2fgu1lfaqwo">
                $27<span className="ml-1 align-top text-2xl text-white sm:text-3xl" data-id="element-213" data-mp="2di73v22as4ze">USD</span>
              </p>
              <p className="mt-2 text-base font-semibold text-white" data-id="element-214" data-mp="28kyjcutofouz">
                One-time payment. No subscription. Instant digital access.
              </p>
              <p className="mx-auto mt-3 flex max-w-md items-start justify-center gap-2 rounded-xl bg-spark/10 px-4 py-2.5 text-left text-sm font-medium text-white" data-id="element-215" data-mp="2ifysnn7nbazd">
                <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-spark" aria-hidden="true" data-id="element-216" data-mp="2rhzoqgr57qzg" />
                Currency conversion is automatic — you’ll see the price in your local currency at checkout.
              </p>
            </div>

            <div className="mt-7" data-id="element-217" data-mp="318udpsvrx4ol">
              <ScarcityBar data-id="element-218" data-mp="319m6yx1weqbp" />
            </div>

            <div className="mt-7" data-id="element-219" data-mp="3f6j0x7dbcnwt">
              <CtaButton label="Yes! I want the complete blueprint for $27" sub="Instant Digital Access • One-Time Payment • 7-Day Guarantee" data-id="element-220" data-mp="3f7k8h1v4es9s" />
            </div>

            <div className="mt-6" data-id="element-221" data-mp="18gxsdpalueel">
              <Countdown data-id="element-222" data-mp="1dhlga23jef4l" />
            </div>

            <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-223" data-mp="1dgk57xmitsmv">
              {trust.map(t => {
              const Icon = t.icon;
              return <li key={t.label} className="flex items-center gap-1.5 text-sm font-semibold text-mist" data-id="element-224" data-mp="1m9x55jj05uig">
                    <Icon className="h-4 w-4 text-ok" aria-hidden="true" data-id="element-225" data-mp="pm0lu6w6kl3j" />
                    {t.label}
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}